import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import React, { useEffect } from 'react';
import { LoginPage } from './pages/Login';
import { ExpressPage } from "./pages/ExpressPage";
import { DepositsPage } from './pages/Deposits';
import { DepositsCreditCardPage } from './pages/DepositsCreditCard';
import { DepositsZellePage } from './pages/DepositZelle';
import { DepositsP2PPage } from './pages/DepositsP2P';
import { DepositCryptoPage } from './pages/DepositCrypto';
import { DepositEwalletPage } from './pages/DepositEwallet';
import { DepositAeropayPage } from './pages/DepositAeropay'
import { DepositECheckPage } from './pages/DepositCheck';
import { DepositGenericPage } from './pages/DepositGeneric';
import { DepositTwoStepPage } from './pages/DepositTwoStep';
import { DepositCoinflowPage } from './pages/DepositCoinflow'
import { PayoutsPage } from './pages/Payouts';
import { PayoutCryptoPage } from './pages/PayoutCrypto';
import { PayoutGenericPage } from './pages/PayoutGeneric';
import { PayoutCheckPage } from './pages/PayoutCheck';
import { PayoutWalletPage } from './pages/PayoutWallet';
import { PayoutAeropayPage } from './pages/PayoutAeropay'
import { PayoutCoinflowPage } from './pages/PayoutCoinflow'
import { PayoutRTPPage } from './pages/PayoutRTP'
import { ExpiredPage } from './pages/expired';
import { PayoutHistoryPage } from './pages/PayoutHistory'
import { MissingPage } from './pages/MissingInfo';


function App() {
    //const client = new QueryClient();
    useEffect(() => {
        let timeout;

        const observer = new ResizeObserver(() => {
            if (timeout) {
                clearTimeout(timeout);
            }
            timeout = setTimeout(() => {
                window.parent.postMessage(
                    { 'full-content-height': document.body.scrollHeight + 35 },
                    '*'
                );
            }, 400);
        });

        if (document.body) {
            observer.observe(document.body);
        }

        return () => {
            observer.disconnect();
            if (timeout) {
                clearTimeout(timeout);
            }
        };
    }, []);


    return (
        <BrowserRouter basename="/">
            <Routes>
                <Route path="/" element={<LoginPage />} />
                <Route path="/main/" element={<ExpressPage />} />
                <Route path="/missing/" element={<MissingPage />} />
                <Route path="/deposits/:id" element={<DepositsPage />} />
                <Route path="/deposits/" element={<DepositsPage />} />
                <Route path="/deposits/creditcard/:id" element={<DepositsCreditCardPage />} />
                <Route path="/deposits/zelle/:id" element={<DepositsZellePage />} />
                <Route path="/deposits/aeropay/:id" element={<DepositAeropayPage />} />
                <Route path="/deposits/p2p/:id" element={<DepositsP2PPage />} />
                <Route path="/deposits/crypto/:id" element={<DepositCryptoPage />} />
                <Route path="/deposits/ewallet/:id" element={<DepositEwalletPage />} />
                <Route path="/deposits/check/" element={<DepositECheckPage />} />
                <Route path="/deposits/generic/:id" element={<DepositGenericPage />} />
                <Route path="/deposits/coinflow/:id" element={<DepositCoinflowPage />} />
                <Route path="/deposits/dualstep/:id" element={<DepositTwoStepPage />} />
                <Route path="/payouts/" element={<PayoutsPage />} />
                <Route path="/payoutHistory/" element={<PayoutHistoryPage />} />
                <Route path="/payouts/crypto/:id" element={<PayoutCryptoPage />} />
                <Route path="/payouts/generic/:id" element={<PayoutGenericPage />} />
                <Route path="/payouts/check/:id" element={<PayoutCheckPage />} />
                <Route path="/payouts/wallet/:id" element={<PayoutWalletPage />} />
                <Route path="/payouts/aeropay/:id" element={<PayoutAeropayPage />} />
                <Route path="/payouts/coinflow/:id" element={<PayoutCoinflowPage />} />
                <Route path="/payouts/rtp/:id" element={<PayoutRTPPage />} />
                <Route path="/expired/" element={<ExpiredPage/> } />
            </Routes>
        </BrowserRouter>

    );
}

export default App;
